import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpResponseInterface } from '../interfaces/iHttpResponse';
import { Category } from '../models/category';
import { RoleFilters } from '../models/roleFilters';
import {RoleStreamFilters} from "../models/roleStreamFilters";

// duplicate filter

@Injectable({
  providedIn: 'root'
})

export class CategoryService {

    constructor(private http: HttpClient) {
    }

    public getCategories(): Observable<Category[]> {
        return this.http.get<Category[]>(environment.apiEndpoint + `/api/category`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getCategory(category_id:number): Observable<any> {
        return this.http.get<any>(environment.apiEndpoint + `/api/category/${category_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getCategoryCourses(category_id:number, roleFilters:RoleFilters, loggedIn:boolean=false, onlyPublished:boolean=false): Observable<any> {
      let userRoles=[];
      if (roleFilters.vet) userRoles.push(1);
      if (roleFilters.vetNurse) userRoles.push(2);
      if (roleFilters.nonClinical) userRoles.push(3);
      if (roleFilters.practiceContent) userRoles.push(4);

      if (loggedIn) {
        return this.http.get<any>(environment.apiEndpoint + `/api/category/coursesWithMeta/${category_id}?user_roles=`+userRoles.join()+`&published=`+onlyPublished).pipe(
          map(res => {
              return res;
          })
      );
      } else {
        return this.http.get<any>(environment.apiEndpoint + `/api/category/courses/${category_id}?user_roles=`+userRoles.join()+`&published=`+onlyPublished).pipe(
          map(res => {
              return res;
          })
        );
      }
    }

    public getCategoryStreams(category_id:number, roleStreamFilters:RoleStreamFilters): Observable<any> {
        let userRoles=[];
        if (roleStreamFilters.vet) userRoles.push(1);
        if (roleStreamFilters.vetNurse) userRoles.push(2);
        if (roleStreamFilters.nonClinical) userRoles.push(3);
        if (roleStreamFilters.practiceContent) userRoles.push(4);

        let endpoint = environment.apiEndpoint + `/api/category/streams/${category_id}`;
        if (userRoles.length >= 1) {
            endpoint = environment.apiEndpoint + `/api/category/streams/${category_id}?user_roles=`+userRoles.join();
        }

        return this.http.get<any>(endpoint).pipe(
            map(
                res => {
                    return res;
                }
            )
        );
    }
}